import React from 'react';

import useStyles from './styles';

interface Props {
    icon: React.ComponentType<{ className?: string }>;
    label: React.ReactNode;
    hidden?: boolean;
    onClick?: () => void;
    className?: string;
}

const ToolbarItem: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (
    { icon: Icon, hidden, label, onClick, className, ...rest },
    ref
) => {
    const { classes, cx } = useStyles();
    return (
        <div
            ref={ref}
            {...rest}
            className={cx(classes.container, { [classes._hidden]: hidden }, className)}
            onClick={hidden ? undefined : onClick}
        >
            <Icon className={classes.icon} />
            <span className={classes.title}>{label}</span>
        </div>
    );
};

export default React.forwardRef(ToolbarItem);
